__turbopack_context__.v({
  "calculatedAmount": "lr4ZNG_calculatedAmount",
  "causeAreas": "lr4ZNG_causeAreas",
  "distributionCauseAreaInputContainer": "lr4ZNG_distributionCauseAreaInputContainer",
  "distributionCauseAreaInputHeader": "lr4ZNG_distributionCauseAreaInputHeader",
  "distributionCauseAreaInputPercentageShare": "lr4ZNG_distributionCauseAreaInputPercentageShare",
  "values": "lr4ZNG_values",
  "valuesAmountContainer": "lr4ZNG_valuesAmountContainer",
  "valuesDatePickerContainer": "lr4ZNG_valuesDatePickerContainer",
  "valuesTaxUnitSelectorContainer": "lr4ZNG_valuesTaxUnitSelectorContainer",
  "wrapper": "lr4ZNG_wrapper",
});
